import React from "react"
import Button from "../Button"
import { FieldWrapper } from "./Field"
import "./Submit.scss"

export default ({label}) => (
  <FieldWrapper modifier="submit">
    <Button modifier="primary" type="submit" handleClick={() => true}>{label}</Button>
  </FieldWrapper>
)